import { Button } from '@mui/material'
import type React from 'react'
import { FormattedMessage } from 'react-intl'

import * as S from './styles'

export interface ErrorPageProps {
  /** Height of the box the block centres itself in. The parent owns the
   *  viewport, so pass a real height when this fills the whole screen. */
  minHeight?: string
  onBack?: () => void
  onRefresh: () => void
}

const ErrorPage: React.FC<ErrorPageProps> = ({ minHeight = '60vh', onBack, onRefresh }) => (
  <S.Root minHeight={minHeight}>
    <S.Container>
      <S.InnerContainer>
        <div>
          <S.Header variant="h4">
            <FormattedMessage
              defaultMessage="Something went wrong"
              description="error page heading"
            />
          </S.Header>
          <S.Body variant="body1">
            <FormattedMessage
              defaultMessage="We've hit a problem loading this page. Refreshing usually fixes it."
              description="error page body"
            />
          </S.Body>
        </div>
        <S.ButtonContainer>
          {onBack ? (
            <>
              <Button color="secondary" variant="contained" onClick={onBack}>
                <FormattedMessage
                  defaultMessage="Back to home"
                  description="error page home button"
                />
              </Button>
              <S.Conjunction>
                <FormattedMessage
                  defaultMessage="or"
                  description="error page between two buttons"
                />
              </S.Conjunction>
            </>
          ) : null}
          <Button color="primary" variant="contained" onClick={onRefresh}>
            <FormattedMessage
              defaultMessage="Refresh page"
              description="error page refresh button"
            />
          </Button>
        </S.ButtonContainer>
      </S.InnerContainer>
      <div>
        <S.NotFoundImage />
      </div>
    </S.Container>
  </S.Root>
)
ErrorPage.displayName = 'ErrorPage'
export default ErrorPage
